import { store } from "src/shared/store";
import { setCurrencyType } from "../productsSlice";

const setStoreCurrencyType = (currencyType: string) => {
  if (!currencyType) return;

  store.dispatch(setCurrencyType(currencyType));
};

export default setStoreCurrencyType;
